import { ConfirmModal } from '@vrplatform/components';
import { useTrpcMutation } from '@vrplatform/data';
import type { Maybe } from '@vrplatform/utils';
import { useDebouncedValue } from '@mantine/hooks';
import type { ListingData } from '../detail/useListingDetailViewQuery';
import { ListingMigrateModal } from './ListingMigrateModal';

type Props = {
  listing: {
    id: string;
    name: Maybe<string>;
    tenantId: string;
    deactivation: ListingData['deactivation'] | undefined;
  } | null;
  deleteModal: {
    opened: boolean;
    closeModal: () => void;
  };
  migrationModal: {
    opened: boolean;
    closeModal: () => void;
  };
};
export const LegacyListingEllipsisMenuModals = ({
  deleteModal,
  listing: initial,
  migrationModal,
}: Props) => {
  const [debounced] = useDebouncedValue(initial, 500);
  const listing = initial || debounced;

  if (!listing) return null;

  return (
    <>
      <Delete listing={listing} {...deleteModal} />

      <ListingMigrateModal
        close={migrationModal.closeModal}
        opened={migrationModal.opened}
        listingId={listing.id}
        listingTeamId={listing.tenantId}
        listingName={listing.name}
      />
    </>
  );
};

const Delete = ({
  closeModal,
  listing: initial,
  opened,
}: {
  listing: NonNullable<Props['listing']>;
} & Props['deleteModal']) => {
  const [debounced] = useDebouncedValue(initial, 500);

  const listing = initial || debounced;

  const { mutate, loading } = useTrpcMutation('deleteListing', {
    successMessage: { message: 'Successfully deleted listing.' },
    invalidateQueryKeys: ['listings'],
  });

  const removeListing = async () => {
    const res = await mutate({
      foreignObjectId: listing.id,
      tenantId: listing.tenantId,
    });

    if (res?.ok) {
      closeModal();
    }
  };

  return (
    <ConfirmModal
      type="delete"
      opened={opened}
      closeModal={closeModal}
      title={`Are you sure to delete ${
        listing.name ? listing.name : 'this listing'
      }?`}
      subtitle="Once deleted all data will be lost."
      onSubmit={() => removeListing()}
      loading={loading}
    />
  );
};
